export const footerEnLocale = {
  'footer.copyrigth': ' {year} All rights reserved',
  'footer.description':
    'By continuing on this page, you agree to be bound by our',
  'footer.wehelp': 'We are here to help',
  'footer.login': 'Login',
  'footer.help': 'Help',
  'footer.join': 'Join us',
  'footer.sell': 'Sell your event with us',
  'footer.marketing': 'Advertise with us',
  'footer.work': 'Work with us',
  'footer.company': 'Company information',
  'footer.contact': 'Contact us',
  'footer.privacy': 'Privacy policy',
  'footer.terms': 'Terms and conditions',
} as const;

export const footerEsLocale = {
  'footer.copyrigth': ' {year} Todos los derechos reservados',
  'footer.description':
    'Al continuar en esta página, usted acuerda regirse por nuestros',
  'footer.wehelp': 'Estamos para ayudarlo',
  'footer.login': 'Ingresar',
  'footer.help': 'Ayuda',
  'footer.join': 'Únete',
  'footer.sell': 'Vende tu evento con nosotros',
  'footer.marketing': 'Publicidad con nosotros',
  'footer.work': 'Trabaja con nosotros',
  'footer.company': 'Información de la compañía',
  'footer.contact': 'Contacte con nosotros',
  'footer.privacy': 'Política de privacidad',
  'footer.terms': 'Términos y condiciones',
} as const;
